import ExampleSlice from './example.slice';

export const { actions: example_actions } = ExampleSlice;

export default ExampleSlice.reducer;
